import Icon from '@chegg-wt/core/components/Icon'
import styled from 'styled-components'
import { Button, OutlineButton } from '@chegg-ui/button'
import { spacing, font } from '@chegg-ui/theme'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: ${spacing.px8};
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), 20)}) {
    justify-content: flex-end;
  }
`

const SubContainer = styled.div`
  display: flex;
  align-items: center;
`

export const AlertContainer = styled(SubContainer)`
  margin: ${spacing.px4} 0;
`

export const ButtonContainer = styled(SubContainer)``

export const ExclamationPoint = styled(Icon)`
  color: ${({ theme }) => theme.Colors.colorImportant};
  width: 20px;
`

export const Text = styled.p`
  font-size: ${font.size.px14};
`

export const ReviewButton = styled(Button)`
  margin: 0 ${spacing.px8};
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  background-color: ${({ theme }) => theme.Colors.primaryColor};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`

export const IgnoreButton = styled(OutlineButton)`
  background-color: ${(props) => props.theme.colors.white};
  color: ${({ theme }) => theme.Colors.primaryColor};
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`
